import { BASE_PATH as c, BaseAPI as I, operationServerMap as h } from "../base.js";
import { DUMMY_BASE_URL as b, assertParamExists as d, createRequestFunction as i, serializeDataIfNeeded as V, setSearchParams as p, toPathString as u } from "../common.js";
import O from "axios";
var A = function(t) {
  return {
    merchantMmsMemberLevelCreateMemberLevel: async (s, a = {}) => {
      d("merchantMmsMemberLevelCreateMemberLevel", "mmsMemberLevelUpsertDTO", s);
      const l = new URL("/merchant/mms/memberLevel", b);
      let r;
      t && (r = t.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...a
      }, m = {}, n = {};
      m["Content-Type"] = "application/json", p(l, n);
      let M = r && r.headers ? r.headers : {};
      return e.headers = {
        ...m,
        ...M,
        ...a.headers
      }, e.data = V(s, e, t), {
        url: u(l),
        options: e
      };
    },
    merchantMmsMemberLevelDeleteById: async (s, a = {}) => {
      d("merchantMmsMemberLevelDeleteById", "merchantMemberLevelId", s);
      const l = "/merchant/mms/memberLevel/{merchantMemberLevelId}".replace("{merchantMemberLevelId}", encodeURIComponent(String(s))), r = new URL(l, b);
      let e;
      t && (e = t.baseOptions);
      const m = {
        method: "DELETE",
        ...e,
        ...a
      }, n = {};
      p(r, {});
      let M = e && e.headers ? e.headers : {};
      return m.headers = {
        ...n,
        ...M,
        ...a.headers
      }, {
        url: u(r),
        options: m
      };
    },
    merchantMmsMemberLevelGetALLMemberLevelList: async (s, a = {}) => {
      d("merchantMmsMemberLevelGetALLMemberLevelList", "shopId", s);
      const l = "/merchant/mms/memberLevel/existing/{shopId}".replace("{shopId}", encodeURIComponent(String(s))), r = new URL(l, b);
      let e;
      t && (e = t.baseOptions);
      const m = {
        method: "GET",
        ...e,
        ...a
      }, n = {};
      p(r, {});
      let M = e && e.headers ? e.headers : {};
      return m.headers = {
        ...n,
        ...M,
        ...a.headers
      }, {
        url: u(r),
        options: m
      };
    },
    merchantMmsMemberLevelGetMemberLevelList: async (s, a = {}) => {
      d("merchantMmsMemberLevelGetMemberLevelList", "shopId", s);
      const l = "/merchant/mms/memberLevel/{shopId}".replace("{shopId}", encodeURIComponent(String(s))), r = new URL(l, b);
      let e;
      t && (e = t.baseOptions);
      const m = {
        method: "GET",
        ...e,
        ...a
      }, n = {};
      p(r, {});
      let M = e && e.headers ? e.headers : {};
      return m.headers = {
        ...n,
        ...M,
        ...a.headers
      }, {
        url: u(r),
        options: m
      };
    },
    merchantMmsMemberLevelUpdateMemberLevel: async (s, a = {}) => {
      d("merchantMmsMemberLevelUpdateMemberLevel", "mmsMemberLevelUpsertDTO", s);
      const l = new URL("/merchant/mms/memberLevel", b);
      let r;
      t && (r = t.baseOptions);
      const e = {
        method: "PUT",
        ...r,
        ...a
      }, m = {}, n = {};
      m["Content-Type"] = "application/json", p(l, n);
      let M = r && r.headers ? r.headers : {};
      return e.headers = {
        ...m,
        ...M,
        ...a.headers
      }, e.data = V(s, e, t), {
        url: u(l),
        options: e
      };
    }
  };
}, L = function(t) {
  const s = A(t);
  return {
    async merchantMmsMemberLevelCreateMemberLevel(a, l) {
      var r, e;
      const m = await s.merchantMmsMemberLevelCreateMemberLevel(a, l), n = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, M = (e = h["MerchantMmsMemberLevelApi.merchantMmsMemberLevelCreateMemberLevel"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (v, o) => i(m, O, c, t)(v, M || o);
    },
    async merchantMmsMemberLevelDeleteById(a, l) {
      var r, e;
      const m = await s.merchantMmsMemberLevelDeleteById(a, l), n = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, M = (e = h["MerchantMmsMemberLevelApi.merchantMmsMemberLevelDeleteById"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (v, o) => i(m, O, c, t)(v, M || o);
    },
    async merchantMmsMemberLevelGetALLMemberLevelList(a, l) {
      var r, e;
      const m = await s.merchantMmsMemberLevelGetALLMemberLevelList(a, l), n = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, M = (e = h["MerchantMmsMemberLevelApi.merchantMmsMemberLevelGetALLMemberLevelList"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (v, o) => i(m, O, c, t)(v, M || o);
    },
    async merchantMmsMemberLevelGetMemberLevelList(a, l) {
      var r, e;
      const m = await s.merchantMmsMemberLevelGetMemberLevelList(a, l), n = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, M = (e = h["MerchantMmsMemberLevelApi.merchantMmsMemberLevelGetMemberLevelList"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (v, o) => i(m, O, c, t)(v, M || o);
    },
    async merchantMmsMemberLevelUpdateMemberLevel(a, l) {
      var r, e;
      const m = await s.merchantMmsMemberLevelUpdateMemberLevel(a, l), n = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, M = (e = h["MerchantMmsMemberLevelApi.merchantMmsMemberLevelUpdateMemberLevel"]) === null || e === void 0 || (e = e[n]) === null || e === void 0 ? void 0 : e.url;
      return (v, o) => i(m, O, c, t)(v, M || o);
    }
  };
}, S = function(t, s, a) {
  const l = L(t);
  return {
    merchantMmsMemberLevelCreateMemberLevel(r, e) {
      return l.merchantMmsMemberLevelCreateMemberLevel(r.mmsMemberLevelUpsertDTO, e).then((m) => m(a, s));
    },
    merchantMmsMemberLevelDeleteById(r, e) {
      return l.merchantMmsMemberLevelDeleteById(r.merchantMemberLevelId, e).then((m) => m(a, s));
    },
    merchantMmsMemberLevelGetALLMemberLevelList(r, e) {
      return l.merchantMmsMemberLevelGetALLMemberLevelList(r.shopId, e).then((m) => m(a, s));
    },
    merchantMmsMemberLevelGetMemberLevelList(r, e) {
      return l.merchantMmsMemberLevelGetMemberLevelList(r.shopId, e).then((m) => m(a, s));
    },
    merchantMmsMemberLevelUpdateMemberLevel(r, e) {
      return l.merchantMmsMemberLevelUpdateMemberLevel(r.mmsMemberLevelUpsertDTO, e).then((m) => m(a, s));
    }
  };
}, x = class extends I {
  merchantMmsMemberLevelCreateMemberLevel(t, s) {
    return L(this.configuration).merchantMmsMemberLevelCreateMemberLevel(t.mmsMemberLevelUpsertDTO, s).then((a) => a(this.axios, this.basePath));
  }
  merchantMmsMemberLevelDeleteById(t, s) {
    return L(this.configuration).merchantMmsMemberLevelDeleteById(t.merchantMemberLevelId, s).then((a) => a(this.axios, this.basePath));
  }
  merchantMmsMemberLevelGetALLMemberLevelList(t, s) {
    return L(this.configuration).merchantMmsMemberLevelGetALLMemberLevelList(t.shopId, s).then((a) => a(this.axios, this.basePath));
  }
  merchantMmsMemberLevelGetMemberLevelList(t, s) {
    return L(this.configuration).merchantMmsMemberLevelGetMemberLevelList(t.shopId, s).then((a) => a(this.axios, this.basePath));
  }
  merchantMmsMemberLevelUpdateMemberLevel(t, s) {
    return L(this.configuration).merchantMmsMemberLevelUpdateMemberLevel(t.mmsMemberLevelUpsertDTO, s).then((a) => a(this.axios, this.basePath));
  }
};
export {
  x as MerchantMmsMemberLevelApi,
  A as MerchantMmsMemberLevelApiAxiosParamCreator,
  S as MerchantMmsMemberLevelApiFactory,
  L as MerchantMmsMemberLevelApiFp
};

//# sourceMappingURL=merchant-mms-member-level-api.js.map